import AppConfig from '@/AppConfig';
import type { ExternalPaymentResultStatus } from '../global';

const initMobileEvents = () => {
  window.onMobileBackPress = onMobileBackPress;
  window.onExternalPaymentResult = onExternalPaymentResult;
};

const onMobileBackPress = () => {
  window.dev.i('onMobileBackPress: Back pressed');
  window.dispatchEvent(new CustomEvent(AppConfig.MOBILE_BACK_PRESS_EVENT));
};

const onExternalPaymentResult = (
  status: ExternalPaymentResultStatus,
  finalUrl?: string,
) => {
  window.dev.i('onExternalPaymentResult:', status, finalUrl);
  window.dispatchEvent(
    new CustomEvent(AppConfig.EXTERNAL_PAYMENT_RESULT_EVENT, {
      detail: { status, finalUrl },
    }),
  );
};

export default initMobileEvents;
